<template>
  <div>

    <div
      v-if="isMobile"
      class="d-flex align-items-center px-3 py-2 bg-light shadow-sm sticky-top"
    >
      <b-button variant="link" class="p-0 mr-2" @click="drawerOpen = true">
        <b-icon-list></b-icon-list>
      </b-button>
      <span class="font-weight-bold">{{ activeTabTitle }}</span>
    </div>

    <b-sidebar
      id="products-drawer"
      title="Products Menu"
      bg-variant="light"
      text-variant="dark"
      shadow
      backdrop
      placement="left"
      :visible="drawerOpen"
      @hidden="drawerOpen = false"
    >
      <hr />
      <ul class="list-unstyled m-0">
        <li
          v-for="(tab, index) in filteredTabs"
          :key="index"
          class="mb-2"
        >
          <b-button
            block
            squared
            :variant="activeTabIndex === index ? null : 'link'"
            class="text-left"
            @click="selectTab(index)"
          >
            <b-icon :icon="tab.icon" class="mr-2"></b-icon>
            {{ tab.title }}
          </b-button>
        </li>
      </ul>
    </b-sidebar>

    <div v-if="!isMobile">
      <b-tabs card lazy v-model="activeTabIndex">
        <b-tab
          v-for="(tab, index) in filteredTabs"
          :key="index"
          :title="tab.title"
        >
          <keep-alive>
            <component :is="tab.component"></component>
          </keep-alive>
        </b-tab>
      </b-tabs>
    </div>

    <div v-if="isMobile" class="mt-2">
      <keep-alive>
        <component
          v-if="activeTabComponent"
          :is="activeTabComponent"
        ></component>
      </keep-alive>
    </div>

  </div>
</template>

<script>
import {
  BIconList,
  BIconBox,
  BIconClipboard,
  BIconArchive,
  BIconFileText
} from "bootstrap-vue";

import ProductsListProducts from "@/components/Products/ProductsListProducts";
import ProductCatalog from "@/components/Products/ProductCatalog";
import AddProducts from "@/components/Products/AddProducts";
import AddGroup from "@/components/Products/AddGroup";
import ProductsSellingHistory from "@/components/Products/ProductsSellingHistory";
import LowInventory from "@/components/Products/LowInventory";
import EditableProductsList from "@/components/Products/EditProductList";

export default {
  name: "ProductsMain",

  components: {
    ProductsListProducts,
    ProductCatalog,
    AddProducts,
    AddGroup,
    ProductsSellingHistory,
    LowInventory,
    EditableProductsList,
    BIconList,
    BIconBox,
    BIconClipboard,
    BIconArchive,
    BIconFileText
  },

  data() {
    return {
      drawerOpen: false,
      activeTabIndex: 0,
      isMobile: false,

      packet: { userDetails: {} },

      tabs: [
        {
          title: "LIST PRODUCTS",
          icon: "box",
          roles: [
            "admin","accountmanager","officeuser","officemanager",
            "locationadmin","locationstockperson","salesperson",
            "warehouseuser","warehousemanager","accountuser"
          ],
          component: "ProductsListProducts"
        },
       
        {
          title: "CATALOG",
          icon: "file-text",
          roles: [
            "admin","accountmanager","officeuser","officemanager",
            "locationadmin","locationstockperson","salesperson",
            "warehouseuser","warehousemanager","accountuser"
          ],
          component: "ProductCatalog"
        },
        {
          title: "ADD PRODUCTS",
          icon: "archive",
          roles: ["admin","officemanager"],
          component: "AddProducts"
        },
        {
          title: "ADD PRODUCT GROUP",
          icon: "archive",
          roles: ["admin","officemanager"],
          component: "AddGroup"
        },
        {
          title: "ITEM HISTORY",
          icon: "clipboard",
          roles: [
            "admin","accountmanager","officeuser","officemanager",
            "locationadmin","locationstockperson","salesperson",
            "warehouseuser","warehousemanager","accountuser"
          ],
          component: "ProductsSellingHistory"
        },
          {
          title: "EDIT PRODUCTS",
          icon: "archive",
          roles: ["admin","officemanager","locationadmin"],
          component: "EditableProductsList"
        },
         {
    title: "LOW INVENTORY",
    icon: "exclamation-triangle", // New icon
    roles: [
      "admin","accountmanager","officeuser","officemanager",
      "locationadmin","locationstockperson","warehousemanager"
    ],
    component: "LowInventory" // Add this new component
  },
        
        
      ]
    };
  },

  computed: {
    filteredTabs() {
      const role = this.packet.userDetails.userrole || "";
      return this.tabs.filter(tab => tab.roles.includes(role));
    },
    activeTabTitle() {
      const tab = this.filteredTabs[this.activeTabIndex];
      return tab ? tab.title : "Menu";
    },
    activeTabComponent() {
      const tab = this.filteredTabs[this.activeTabIndex];
      return tab ? tab.component : null;
    }
  },

  methods: {
    selectTab(index) {
      this.activeTabIndex = index;
      this.drawerOpen = false;
    },

    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },

    loadUser() {
      try {
        this.packet = JSON.parse(localStorage.packet || "{}");
        this.packet.userDetails = JSON.parse(localStorage.userDetails || "{}");
      } catch (err) {
        console.error("Error parsing user data:", err);
      }
    }
  },

  created() {
    this.loadUser();
  },

  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style scoped>
@media (max-width: 767px) {
  .b-tabs {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Products/ProductsMain.vue